<template>
  <UContainer>
    <UHeader
      :links="links"
      :ui="{ container: 'px-0 sm:px-0 lg:px-0' }"
      id="header"
      :to="config.public.websiteUrl ?? '/'"
    >
      <template #logo>
        <Logo class="w-auto h-6" />
      </template>

      <template #center>
        <div class="hidden lg:flex">
          <UHorizontalNavigation
            :links="links"
            :ui="{
              active: 'after:bg-transparent',
              base: 'text-md',
              container: 'space-x-8',
            }"
          >
            <template #default="{ link }">
              <span class="relative">{{ link.label }}</span>
            </template>
          </UHorizontalNavigation>
        </div>
      </template>

      <template #right>
        <div class="flex space-x-4 mr-2 lg:mr-0">
          <UChip
            :text="cartStore.itemCount"
            size="xl"
            color="brand-action"
            :show="cartStore.itemCount > 0"
            :ui="{ base: `${animateCartChip && 'animate-shake'}` }"
          >
            <UButton
              id="shopping-cart-button"
              icon="i-heroicons-outline-shopping-cart"
              color="gray"
              size="xl"
              variant="ghost"
              @click="$emitEvent('open-shopping-cart')"
              :loading="!cartStore.initialized && !cartStore.error"
              :disabled="cartStore.error"
            />
          </UChip>

          <UPopover :popper="{ strategy: 'absolute' }">
            <UButton
              color="gray"
              variant="ghost"
              trailing-icon="i-heroicons-outline-user-circle"
              size="xl"
            />

            <template #panel="{ close }">
              <div class="p-4 w-60 flex space-y-4 flex-col">
                <template v-if="authStore.isAuthenticated">
                  <div>
                    Du er innlogget som
                    <template v-if="authStore.isPartner">
                      partner <b>{{ authStore.partnerName }}</b>
                    </template>
                    <template v-else>
                      <b>{{ authStore.customerName }}</b>
                    </template>
                  </div>
                  <div>
                    <UButton @click="logout(close)">Logg ut</UButton>
                  </div>
                </template>
                <template v-else>
                  <div>Du er ikke innlogget.</div>
                  <div>
                    <UButton to="/logg-inn" @click="close">Logg inn</UButton>
                  </div>
                </template>
              </div>
            </template>
          </UPopover>
        </div>
      </template>
    </UHeader>
    <UMain>
      <NuxtPage />
    </UMain>
  </UContainer>
</template>

<script setup lang="ts">
import type { HeaderLink } from "@nuxt/ui-pro/types";

const { $emitEvent } = useNuxtApp();
const cartStore = useCartStore();
const config = useRuntimeConfig();
const authStore = useAuthStore();

interface LocalHeaderLink extends HeaderLink {
  icon?: string;
}

const animateCartChip = ref(false);

const logout = async (callback: () => void) => {
  await authStore.logout();
  callback();
};

//setInterval(() => (animateCartChip.value = !animateCartChip.value), 1000);

const links = computed<LocalHeaderLink[]>(() => {
  const temp = [];

  if (config.public.canOrderDomain) {
    temp.push({
      label: "Domene",
      icon: "i-heroicons-outline-search",
      to: "/domene/sok",
    });
  }

  if (config.public.canOrderMicrosoft365) {
    temp.push({
      label: "Microsoft 365",
      icon: "i-simple-icons-microsoftoffice",
      to: "/microsoft-365",
    });
  }

  if (config.public.canOrderCloudServer) {
    temp.push({
      label: "Cloud server",
      icon: "i-carbon-ibm-cloud-virtual-server-vpc",
      to: "/cloud-server",
    });
  }

  if (config.public.canOrderWhChat) {
    temp.push({
      label: "Chat",
      icon: "i-heroicons-chat-bubble-left-right",
      to: "/chat",
    });
  }

  return temp;
});
</script>
